import React from "react";
import { FcGoogle } from "react-icons/fc";
import { useGoogleLogin } from "@react-oauth/google";

export const SocialAuth = ({
  handleGoogleSignup,
  handleMicrosoftSignup,
  isSocialLoading,
}) => {
  const googleLogin = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      handleGoogleSignup({ token: tokenResponse.access_token });
    },
    onError: (error) => {
      console.error("[Google OAuth Error]:", error);
    },
    flow: "implicit", // opens the Google account-picker popup immediately
  });

  return (
    <div className="w-100 my-3 text-center">
      <div className="d-flex align-items-center my-3">
        <div className="flex-grow-1 border-bottom"></div>
        <span className="px-3 text-muted font_12 fw-medium">
          OR SIGN UP WITH
        </span>
        <div className="flex-grow-1 border-bottom"></div>
      </div>

      <div className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
        <button
          type="button"
          className="btn d-inline-flex align-items-center gap-2 py-2 px-4 border-0"
          onClick={() => googleLogin()}
          disabled={isSocialLoading}
          style={{
            backgroundColor: "#f1f3f4",
            color: "#3c4043",
            borderRadius: "8px",
            fontWeight: "500",
            fontSize: "14px",
            width: "fit-content",
            boxShadow: "none",
            outline: "none",
            transition: "background-color 0.2s ease-in-out",
            cursor: isSocialLoading ? "not-allowed" : "pointer",
          }}
        >
          <FcGoogle size={16} />
          <span>
            {isSocialLoading ? "Connecting..." : "Continue with Google"}
          </span>
        </button>
      </div>
    </div>
  );
};

export default SocialAuth;
